module.exports = __webpack_public_path__ + "static/csc-5-727353755aa9cd68acd38c9c02eada17.jpg";